import validate from 'jquery-validation';
validate;

export default class NewsletterForm {
    constructor() {
        this.section = document.querySelector('.component-newsletter');

        this.ready();
    }

    ready() {
        if (this.section) {
            function setupForm() {
                // const container = $('.newsletter');
                const formNewsletter = $('.form-newsletter');
                const formNewsletterSuccess = $('.form-newsletter .success');
                const formNewsletterErrors = $('.form-newsletter .errors');
                const btnSubmit = $('.form-newsletter .btn-submit');

                formNewsletter.find("input[name='dt_birthday']").mask('00/00/0000');
                formNewsletter.find("input[name='phone']").mask('(00) 00000-0000');

                formNewsletter.find("input[name='email']").on('focus', function () {
                    loadRecaptchaV3();
                    $('.expand-form-newsletter').addClass('active');
                    $('.btn-close-newsletter').removeClass('hidden');
                });

                //custom validation rule
                //custom validation rule
                $.validator.addMethod(
                    'customemail',
                    function (value, element) {
                        return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
                    },
                    'Digite um e-mail válido'
                );

                $.validator.addMethod(
                    'customname',
                    function (value, element) {
                        return !/[0-9!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/,!?-]/g.test(value);
                    },
                    'Digite um nome válido'
                );

                $.validator.addMethod(
                    'customtel',
                    function (value, element) {
                        if (value.length > 14) {
                            return true;
                        }
                    },
                    'Digite um telefone válido'
                );

                formNewsletter.validate({
                    onFocusOut: true,
                    focusInvalid: false,
                    errorClass: 'input-error',
                    errorElement: 'span',
                    errorLabelContainer: '.form-newsletter .errors',
                    rules: {
                        first_name: {
                            required: {
                                depends: function () {
                                    $(this).val();
                                    return false;
                                },
                            },
                            customname: true,
                        },
                        last_name: {
                            required: {
                                depends: function () {
                                    $(this).val();
                                    return false;
                                },
                            },
                            customname: true,
                        },
                        email: {
                            required: {
                                depends: function () {
                                    $(this).val($(this).val().trim());
                                    return true;
                                },
                            },
                            customemail: true,
                        },
                        dt_birthday: 'required',
                        phone: {
                            required: {
                                depends: function () {
                                    $(this).val();
                                    return false;
                                },
                            },
                            customtel: true,
                        },
                        fl_age: 'required',
                        fl_privacy: 'required',
                    },
                    messages: {
                        first_name: 'O campo "Nome" não foi preenchido',
                        last_name: 'O campo "Sobrenome" não foi preenchido',
                        email: {
                            required: 'O campo "Email" não foi preenchido',
                            email: 'Digite um "Email" válido',
                        },
                        dt_birthday: 'O campo "Data de Nascimento" não foi definido',
                        phone: {
                            required: 'O campo "Celular" não foi preenchido',
                            minlength: 'Digite um "Celular" válido',
                        },
                        fl_age: 'Você precisa confirmar que tem 18 anos ou mais', //TODO: texto
                        fl_privacy: 'Você precisa confirmar se esta de acordo com a coleta de dados', //TODO: texto
                    },
                    invalidHandler: function () {
                        btnSubmit.removeClass('loading');
                        formNewsletter.find('.success').empty();
                    },
                    submitHandler: function (form, event) {
                        if (btnSubmit.hasClass('loading')) {
                            return;
                        }

                        btnSubmit.addClass('loading');

                        event.preventDefault();
                        event.stopPropagation();

                        // reloadCaptcha('contact', 'g-recaptcha-response', function () {
                        //     $.ajax({
                        //         type: 'POST',
                        //         url: $(form).data('action'),
                        //         data: new FormData(form),
                        //         processData: false,
                        //         contentType: false,
                        //         success: function (data) {
                        //             form.reset();
                        //             btnSubmit.removeClass('loading');
                        //             // container.removeClass('is-open');
                        //             document.querySelector('.modal-sucesso-form-newsletter').classList.add('active');
                        //             document
                        //                 .querySelector('.modal-sucesso-form-newsletter .closeModalForm')
                        //                 .addEventListener('click', () => {
                        //                     document.querySelector('.modal-form-newsletter').classList.remove('active');
                        //                 });
                        //             // formNewsletterSuccess.html(data);
                        //         },
                        //         error: function (data) {
                        //             btnSubmit.removeClass('loading');

                        //             formNewsletterSuccess.empty();

                        //             document.querySelector('.modal-erro-form-newsletter').classList.add('active');
                        //             document
                        //                 .querySelector('.modal-erro-form-newsletter .closeModalForm')
                        //                 .addEventListener('click', () => {
                        //                     document.querySelector('.modal-form-newsletter').classList.remove('active');
                        //                 });

                        //             if (data.responseJSON || data.responseText) {
                        //                 formNewsletterErrors
                        //                     .html(
                        //                         data.responseJSON && data.responseJSON.errors
                        //                             ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                        //                             : data.responseJSON.message || data.responseText
                        //                     )
                        //                     .show({ duration: 0 });
                        //             }

                        //             try {
                        //                 reloadCaptcha('contact');
                        //                 document
                        //                     .querySelector('.modal-sucesso-form-newsletter')
                        //                     .classList.remove('active');
                        //             } catch (e) {
                        //                 console.log(e);
                        //             }
                        //         },
                        //     });
                        // });

                        setTimeout(() => {
                            form.reset();
                            btnSubmit.removeClass('loading');
                            // container.removeClass('is-open');
                            document.querySelector('.modal-sucesso-form-newsletter').classList.add('active');
                            document
                                .querySelector('.modal-sucesso-form-newsletter .closeModalForm')
                                .addEventListener('click', () => {
                                    document.querySelector('.modal-form-newsletter').classList.remove('active');
                                });
                        }, 1500);
                    },
                });
            }

            function setupNewsletter() {
                setupForm();

                //Open/Close
                $('.btn-close-newsletter').on('click', function () {
                    $('.expand-form-newsletter').removeClass('active');
                    $('.btn-close-newsletter').addClass('hidden');
                });
            }

            function loadRecaptchaV3() {
                const url = $('.form-newsletter').data('api-recaptcha');

                const s = document.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = url;

                const x = document.getElementsByTagName('head')[0];
                x.appendChild(s);
            }

            function testNewsletter() {
                const formNewsletter = $('.form-newsletter');
                formNewsletter.find("input[name='first_name']").val('Firstname');
                formNewsletter.find("input[name='last_name']").val('Lastname');
                formNewsletter.find("input[name='email']").val('lorem@ipsun.com');
                formNewsletter.find("input[name='phone']").val('54 000000000');
                formNewsletter.find("input[name='dt_birthday']").val('00/00/0000');
                formNewsletter.find("input[name='fl_age']").attr('checked', 'checked');
                formNewsletter.find("input[name='fl_privacy']").attr('checked', 'checked');
            }

            function initialize() {
                setupNewsletter();
                // testNewsletter(); //Apenas para teste
            }

            initialize();
        }
    }
}
if (document.querySelector('.component-newsletter')) {
    new NewsletterForm();
}
